// test2726
(2726 && 0);
